import { useState } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { Charts } from "..";
import * as S from "./RadialChart.style";

interface RadialChartProps {
  title?: string;
  data?: any;
  color?: "yellow" | "green" | "blue";
}

export const RadialChart = ({ title, data, color }: RadialChartProps) => {
  const [options, setOptions] = useState({
    color:
      color === "yellow"
        ? "#FFD000"
        : color === "green"
        ? "#77DA63"
        : color === "blue" && "#1D4ED7",
    series: [
      {
        type: "gauge",
        radius: "100%",
        startAngle: 90,
        endAngle: -360,
        center: ["50%", "50%"],
        min: data.minValue,
        max: data.maxValue,
        progress: {
          show: true,
          width: 10,
        },
        detail: {
          show: true,
          valueAnimation: true,
          color: "#03071B",
          fontSize: "2.2rem",
          fontWeight: "600",
          offsetCenter: [0, "8px"],
          formatter: "{value}%",
        },
        data: [data.value],
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 10,
            color: [[1, "#FFFFFF"]],
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        pointer: {
          show: false,
        },
      },
    ],
  });

  return (
    <Charts title={title}>
      <S.RadialChart>
        <ReactECharts
          echarts={echarts}
          option={options}
          opts={{ renderer: "svg" }}
          style={{ width: "100%", height: "100%" }}
        />
        <S.RadialChartUnit $color={color}>{data.unit}</S.RadialChartUnit>
      </S.RadialChart>
    </Charts>
  );
};
